export const inquiry = {
    url: 'https://forms.office.com/Pages/ResponsePage.aspx?id=JXapM4mRJEqkcdrpCVm6t6iUo2S1p3VKlQk7z1AFQxdUOE81QVRKTzlRSFdLTjlNV1o0NVdFNDdSWi4u',
    img: '/img/Inquiry_24px.svg',
    text: 'お問い合わせ'
}
